import repository from "@/repository/staff";

export default {
    async mapPaginationData({commit, state}, pageNumber) {
        //load report number

        //set report no
        const payload_report_no = localStorage.getItem("report_no");

        const path = `${state.data.path}?page=${pageNumber}`;
        const {data} = await repository.staffMapPaginationData({path});
        data.report_no = payload_report_no; //fix report no when click pagination
        commit("SET_DATA", data);
        console.log("mapPaginationData data when click",data);
        console.log("state",state);
        console.log("commit",commit);
    },
    async fetchData({commit}, payload) {
        const adminArea = localStorage.getItem("adminArea");
        const {data} = await repository.staffSearchPatient({adminArea, report_no: payload.report_no});
        commit("SET_DATA", data);
        console.log("fetchData data",data);
    },
};
